import {
    ChangeDetectionStrategy,
    Component,
    InputSignal,
    input
} from "@angular/core";
import {AbstractField} from "../field/abstract-field";
import {FormsModule, NG_VALUE_ACCESSOR} from "@angular/forms";
import {FieldComponent} from '../field/field.component';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: "woa-text-area-field",
    templateUrl: "./text-area-field.component.html",
    styleUrl: "./text-area-field.component.scss",
    providers: [{provide: NG_VALUE_ACCESSOR, useExisting: TextAreaFieldComponent, multi: true}],
    imports: [
        FieldComponent,
        FormsModule,
        TranslateModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TextAreaFieldComponent extends AbstractField {
    public readonly maxLength: InputSignal<number> = input<number>();
    public readonly spellCheck: InputSignal<boolean> = input<boolean>(true);
}
